export default __webpack_public_path__ + "d5ca1115e135517187d1f3a9f460f468.jpg";